import React from 'react'
import { Button, Icon } from 'semantic-ui-react'
import Proptypes from 'prop-types'
import styles from './device-view.module.css'
import { primaryColor } from '../../../../constants'
import IntelMsg from '../../../ItelMsg'

const DeviceActions = ({ onBackClick }) => (
  <>
    <div className={styles.actions}>
      <Button
        style={{ background: primaryColor, color: 'white' }}
        icon
        labelPosition="left"
        onClick={() => onBackClick()}
      >
        <Icon name="arrow left" />
        <IntelMsg id="back" />
      </Button>
    </div>
  </>
)
DeviceActions.propTypes = {
  onBackClick: Proptypes.func.isRequired,
}

export default DeviceActions
